import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import { persistor } from "./store";
import "./index.css";
import { PersistGate } from "redux-persist/integration/react";
import ReactDOM from "react-dom";
import App from "./App";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root") as HTMLElement
);
